import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const mode = import.meta.env.MODE;
//import LanguageDetector from 'i18next-browser-languagedetector';

// Load translation data at build time
import _en_translations from 'locales/en/translation.json';
import _es_translations from 'locales/es/translation.json';
import _pt_translations from 'locales/pt/translation.json';
import _fr_translations from 'locales/fr/translation.json';
import _nl_translations from 'locales/nl/translation.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: mode !== "production" && mode !== "staging",

    // Detect language set in the browser and try to use it, defaulting to en, and removing the country/regional designation
    lng: (window.navigator.language || "en").split("-")[0].toLowerCase(),

    // If a translation is not available in the selected language, fall back on English
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // react-i18next options
    react: {
      // Wait for the translation to be loaded before rendering the component
      useSuspense: true,
    },
    resources: {
      en: {
        translation: _en_translations
      },
      es: {
        translation: _es_translations
      },
      fr: {
        translation: _fr_translations
      },
      pt: {
        translation: _pt_translations
      },
      nl: {
        translation: _nl_translations
      }
    }
  });

export default i18n;